import React from 'react';
import PropTypes from 'prop-types';

import { translate } from '../Services/translation';

const SunPanelsContactInfoUserForm = ({
  acceptedConditions,
  handleOfferRequest,
}) => {
  return (
    <form
      id="sunpanel-offer-request-form"
      name="sunpanel-offer-request-form"
      className="validate"
      onSubmit={(e) => {
        e.preventDefault();
        const elements = e.target.elements;
        if (elements) {
          const name = elements.NAME.value;
          const email = elements.EMAIL.value;
          const phone = elements.PHONE.value;

          const obj = {
            isuser: true,
            name,
            email,
            phone,
          };

          handleOfferRequest(obj);
        }
      }}
    >
      <div>
        <div className="sunpanel-offer-request-form__group">
          <input
            className="sunpanel-offer-request-form__field"
            name="NAME"
            id="sunpanel-offer-customer-name"
            placeholder={translate('solcellepanel.general.name') + '*'}
            required
            type="text"
          />
          <input
            className="sunpanel-offer-request-form__field"
            name="EMAIL"
            id="sunpanel-offer-customer-email"
            placeholder={translate('solcellepanel.general.emailaddress') + '*'}
            required
            type="email"
          />
          <input
            className="sunpanel-offer-request-form__field"
            name="PHONE"
            id="sunpanel-offer-customer-phone"
            placeholder={translate('solcellepanel.general.phone') + '*'}
            required
            type="tel"
          />
        </div>
        <div className="checkout__step-content-next">
          <button
            type="submit"
            className="button"
            disabled={!acceptedConditions && 'disabled'}
          >
            {translate('solcellepanel.general.makerequestbuttontext')}
          </button>
        </div>
      </div>
    </form>
  );
};

export default SunPanelsContactInfoUserForm;

SunPanelsContactInfoUserForm.propTypes = {
  acceptedConditions: PropTypes.bool.isRequired,
  handleOfferRequest: PropTypes.func.isRequired,
};
